import gql from 'graphql-tag';

export const ETF_AVERAGE_ANNUAL_TOTAL_RETURNS = gql`
    query ETFReturns($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            benchmarks {
                benchmarkCode
                benchmarkName
                benchmarkType
            }
            name
            inceptionDate
            grossExpenseRatio
            netExpenseRatio
            averageAnnualTotalReturns {
                quarterly {
                    asOfDate
                    fundPerformance {
                        performanceType
                        navMonthlyYtdReturn
                        navQuarterlyYtdReturn
                        navOneMonthReturn
                        navThreeMonthReturn
                        navSixMonthReturn
                        navOneYearReturn
                        navThreeYearAnnualizedReturn
                        navFiveYearAnnualizedReturn
                        navTenYearAnnualizedReturn
                        navThreeYearAnnualizedReturn
                        navFiveYearAnnualizedReturn
                        navTenYearAnnualizedReturn
                        navSinceInceptionReturn
                        navSinceInceptionAnnualizedReturn
                        marketPriceMonthlyYtdReturn
                        marketPriceQuarterlyYtdReturn
                        marketPriceOneMonthReturn
                        marketPriceThreeMonthReturn
                        marketPriceSixMonthReturn
                        marketPriceOneYearReturn
                        marketPriceThreeYearAnnualizedReturn
                        marketPriceFiveYearAnnualizedReturn
                        marketPriceTenYearAnnualizedReturn
                        marketPriceSinceInceptionReturn
                        marketPriceSinceInceptionAnnualizedReturn
                        afterTaxPreLiquidMonthlyYtdReturn
                        afterTaxPreLiquidQuarterlyYtdReturn
                        afterTaxPreLiquidOneMonthReturn
                        afterTaxPreLiquidThreeMonthReturn
                        afterTaxPreLiquidSixMonthReturn
                        afterTaxPreLiquidOneYearReturn
                        afterTaxPreLiquidThreeYearReturn
                        afterTaxPreLiquidFiveYearReturn
                        afterTaxPreLiquidTenYearReturn
                        afterTaxPreLiquidSinceInceptionReturn
                        afterTaxPostLiquidMonthlyYtdReturn
                        afterTaxPostLiquidQuarterlyYtdReturn
                        afterTaxPostLiquidOneMonthReturn
                        afterTaxPostLiquidThreeMonthReturn
                        afterTaxPostLiquidSixMonthReturn
                        afterTaxPostLiquidOneYearReturn
                        afterTaxPostLiquidThreeYearReturn
                        afterTaxPostLiquidFiveYearReturn
                        afterTaxPostLiquidTenYearReturn
                        afterTaxPostLiquidSinceInception
                    }
                    benchmarkPerformance {
                        performanceType
                        benchmarkCode
                        navMonthlyYtdReturn
                        navQuarterlyYtdReturn
                        navOneMonthReturn
                        navThreeMonthReturn
                        navSixMonthReturn
                        navOneYearReturn
                        navSinceInceptionReturn
                        navThreeYearAnnualizedReturn
                        navFiveYearAnnualizedReturn
                        navTenYearAnnualizedReturn
                        navSinceInceptionAnnualizedReturn
                        valueAddedMonthlyYtdReturn
                        valueAddedQuarterlyYtdReturn
                        valueAddedOneMonthReturn
                        valueAddedThreeMonthReturn
                        valueAddedSixMonthReturn
                        valueAddedOneYearReturn
                        valueAddedThreeYearAnnualizedReturn
                        valueAddedFiveYearAnnualizedReturn
                        valueAddedTenYearAnnualizedReturn
                        valueAddedSinceInceptionReturn
                        valueAddedSinceInceptionAnnualizedReturn
                    }
                }
                monthly {
                    asOfDate
                    fundPerformance {
                        performanceType
                        navMonthlyYtdReturn
                        navQuarterlyYtdReturn
                        navOneMonthReturn
                        navThreeMonthReturn
                        navSixMonthReturn
                        navOneYearReturn
                        navThreeYearAnnualizedReturn
                        navFiveYearAnnualizedReturn
                        navTenYearAnnualizedReturn
                        navSinceInceptionReturn
                        navSinceInceptionAnnualizedReturn
                        marketPriceMonthlyYtdReturn
                        marketPriceQuarterlyYtdReturn
                        marketPriceOneMonthReturn
                        marketPriceThreeMonthReturn
                        marketPriceSixMonthReturn
                        marketPriceOneYearReturn
                        marketPriceThreeYearAnnualizedReturn
                        marketPriceFiveYearAnnualizedReturn
                        marketPriceTenYearAnnualizedReturn
                        marketPriceSinceInceptionReturn
                        marketPriceSinceInceptionAnnualizedReturn
                        afterTaxPreLiquidMonthlyYtdReturn
                        afterTaxPreLiquidQuarterlyYtdReturn
                        afterTaxPreLiquidOneMonthReturn
                        afterTaxPreLiquidThreeMonthReturn
                        afterTaxPreLiquidSixMonthReturn
                        afterTaxPreLiquidOneYearReturn
                        afterTaxPreLiquidThreeYearReturn
                        afterTaxPreLiquidFiveYearReturn
                        afterTaxPreLiquidTenYearReturn
                        afterTaxPreLiquidSinceInceptionReturn
                        afterTaxPostLiquidMonthlyYtdReturn
                        afterTaxPostLiquidQuarterlyYtdReturn
                        afterTaxPostLiquidOneMonthReturn
                        afterTaxPostLiquidThreeMonthReturn
                        afterTaxPostLiquidSixMonthReturn
                        afterTaxPostLiquidOneYearReturn
                        afterTaxPostLiquidThreeYearReturn
                        afterTaxPostLiquidFiveYearReturn
                        afterTaxPostLiquidTenYearReturn
                        afterTaxPostLiquidSinceInception
                    }
                    benchmarkPerformance {
                        performanceType
                        benchmarkCode
                        navMonthlyYtdReturn
                        navQuarterlyYtdReturn
                        navOneMonthReturn
                        navThreeMonthReturn
                        navSixMonthReturn
                        navOneYearReturn
                        navThreeYearAnnualizedReturn
                        navFiveYearAnnualizedReturn
                        navTenYearAnnualizedReturn
                        navSinceInceptionReturn
                        navSinceInceptionAnnualizedReturn
                        valueAddedMonthlyYtdReturn
                        valueAddedQuarterlyYtdReturn
                        valueAddedOneMonthReturn
                        valueAddedThreeMonthReturn
                        valueAddedSixMonthReturn
                        valueAddedOneYearReturn
                        valueAddedThreeYearAnnualizedReturn
                        valueAddedFiveYearAnnualizedReturn
                        valueAddedTenYearAnnualizedReturn
                        valueAddedSinceInceptionReturn
                        valueAddedSinceInceptionAnnualizedReturn
                    }
                }
                daily {
                    asOfDate
                    fundPerformance {
                        performanceType
                        navDailyYtdReturn
                        marketPriceDailyYtdReturn
                    }
                    benchmarkPerformance {
                        benchmarkCode
                        navDailyYtdReturn
                        valueAddedDailyYtdReturn
                    }
                }
            }
        }
    }
`;
